import { useDesktopMediaQuery, useTabletAndBelowMediaQuery } from '../Search/hooks/useResponsive';

export const Desktop = ( { children } ) => {
	const isDesktop = useDesktopMediaQuery();
	return isDesktop ? children : null;
};

export const TabletAndBelow = ( { children } ) => {
	const isTabletAndBelow = useTabletAndBelowMediaQuery();
	return isTabletAndBelow ? children : null;
};
